import { render, staticRenderFns } from "./attribute_option.vue?vue&type=template&id=1652c507&scoped=true"
import script from "./attribute_option.vue?vue&type=script&lang=js"
export * from "./attribute_option.vue?vue&type=script&lang=js"
import style0 from "./attribute_option.vue?vue&type=style&index=0&id=1652c507&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1652c507",
  null
  
)

export default component.exports